import { ThemeProperties } from '@mutiny-pkg/champaign-schemas/src/schemas/themeProperties/types';

export const CANONICAL_COLOR_ORDER: Array<Exclude<keyof ThemeProperties['color'], 'unset' | 'none'>> = [
  'primary',
  'secondary',
  'tertiary',
  'default',
  'textDark',
  'textLight',
];
